<script>
export default {
    name: 'IconArrowRight',
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="base-icon icon-arrow-right" viewBox="0 0 64 64"><g clip-path="url(#a)"><path fill="currentColor"  fill-rule="evenodd" d="M32.04 0 64 31.867l-.133.132.133.133L32.04 64l-5.64-5.624 22.464-22.4H0v-7.952l48.864-.001-22.465-22.4L32.04 0Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath></defs></svg>
</template>
